export { InternalRelationshipsSection } from "./internal-relationships-section";
